import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';
import { Badge } from '@/components/ui/Badge';
import { CreditCard } from 'lucide-react';
import { formatCurrency, formatDateTime } from '@/utils/formatters';

interface OrgBillingCardProps {
  org: any;
}

export function OrgBillingCard({ org }: OrgBillingCardProps) {
  const subscriptions = org.subscriptions || [];
  const recentBilling = org.recentBilling || [];
  const hasData = subscriptions.length > 0 || recentBilling.length > 0;

  return (
    <Card>
      <CardHeader title="Facturation" description={subscriptions.length > 0 ? `${subscriptions.length} abonnement(s)` : undefined} />
      <CardContent>
        {!hasData ? (
          <EmptyState message="Aucune info facturation" icon={<CreditCard className="h-8 w-8" />} />
        ) : (
          <div className="space-y-3">
            {subscriptions.length > 0 && (
              <div className="space-y-2">
                {subscriptions.map((sub: any) => (
                  <div key={sub.uuid || sub.id} className="flex items-center justify-between rounded-lg bg-neutral-100 dark:bg-neutral-800/50 p-2">
                    <div>
                      <p className="text-xs font-medium text-neutral-700 dark:text-neutral-300">{sub.planName || sub.plan || 'Standard'}</p>
                      <p className="text-xs text-neutral-500">{formatCurrency(sub.amount || sub.monthlyAmount)}/mois</p>
                    </div>
                    <Badge variant={sub.status === 'active' ? 'success' : 'neutral'}>{sub.status || 'N/A'}</Badge>
                  </div>
                ))}
              </div>
            )}
            {recentBilling.length > 0 && (
              <div className="space-y-1">
                <p className="text-xs font-medium text-neutral-500 uppercase">Factures recentes</p>
                {recentBilling.slice(0, 5).map((bill: any) => (
                  <div key={bill.uuid || bill.id} className="flex justify-between text-xs text-neutral-600 dark:text-neutral-400">
                    <span>{formatDateTime(bill.createdAt)}</span>
                    <span className="font-medium">{formatCurrency(bill.totalAmount || bill.amount)}</span>
                  </div>
                ))}
              </div>
            )}
            {org.stripeCustomerUuid && (
              <div className="pt-2 border-t border-neutral-200 dark:border-neutral-700">
                <p className="text-xs text-neutral-500">Stripe: {org.stripeCustomerUuid}</p>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
